import { render, staticRenderFns } from "./NewRecycleBinModal.vue?vue&type=template&id=00082024&scoped=true"
import script from "./NewRecycleBinModal.vue?vue&type=script&lang=js"
export * from "./NewRecycleBinModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00082024",
  null
  
)

export default component.exports